export const secciones = {
  '1': 'NPS',
  '2': 'Afirmações',
  '3': 'Perguntas de controle',
  '4': 'Demografia',
  '5': 'Perguntas abertas',
  '6': '4 Todas as Práticas',
  '7': 'Questões adicionais',
  '8': 'Declarações NOM035',
}
export const preguntas = {
  // '1': 'Pergunta de opção única',
  '1': 'Pergunta de múltipla opção (botão de opção)',
  '2': 'Questão aberta',
  '3': 'Declaração',
  '4': 'Pergunta de múltipla opção (botão de opção)',
  '5': '4Todos os treinos',
  '6': 'Pergunta de múltipla opção (botão de verificação)',
  '7': 'Declaração NOM035',
  '8': 'Áudio',
}
export const abiertas = {
  '1': 'Texto aberto',
  '2': 'Texto numérico',
}
export const preguntasEspeciales = {
  '1': 'Pergunta normal',
  '2': 'Pergunta especial',
}
